import React, { useState } from 'react';

import { getVendors } from '@/services/api/vendors';

import AddVendorModal from '@/components/Modal/AddVendorModal';
import Typography from '@/components/Typography';
import { TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import PaginatedTable from '@/components/ui/paginated';

import { urls } from '@/constants';
import ActivityBadge from '@/components/Badge/ActivityBadge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { Card, CardContent } from '@/components/ui/card';

const VendorsListPage: React.FC = () => {
  const [term, setTerm] = useState('');
  const [open, setOpen] = useState(false);

  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <Typography is="h1" size="2xl" weight="bold">
          Vendors
        </Typography>

        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button variant="outline">Add new</Button>
          </DialogTrigger>
          <DialogContent>
            <AddVendorModal
              close={() => setOpen(false)}
              onSubmit={() => {
                console.log('reload');
                setOpen(false);
              }}
            />
          </DialogContent>
        </Dialog>
      </div>

      <Input placeholder="Filter by name " onChange={(e) => setTerm(e.target.value)} />

      <Card>
        <CardContent>
          <PaginatedTable
            key={term}
            source={(page, number) => getVendors(page, number, term)}
            renderHeader={() => (
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Status</TableHead>
                </TableRow>
              </TableHeader>
            )}
          >
            {(data) => (
              <TableBody>
                {data.map((vendor) => (
                  <TableRow key={vendor.id} url={urls.vendors.detail.get(vendor.id)}>
                    <TableCell className="whitespace-normal break-words">
                      <div className="flex space-x-4 align-middle">
                        <img src={vendor.thumbnailUrl} className="object-cover w-12 h-12 bg-gray-200 rounded-lg" />
                        <div>
                          <Typography is="h2" className="bold">
                            {vendor.name}
                          </Typography>
                          <Typography is="span" size="sm">
                            {vendor.description}
                          </Typography>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <ActivityBadge active={vendor.active} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </PaginatedTable>
        </CardContent>
      </Card>
    </div>
  );
};

export default VendorsListPage;
